// Components
import Container from "@/components/Container";
import Columns from "@/components/Columns";
import Column from "@/components/Column";
import Text from "@/components/Text";
import Button from "@/components/Button";
import { useNavigate } from "react-router-dom";
import SEO from "@/components/SEO";

// Not Found
export const NotFound = () => {
  const navigate = useNavigate();
  return (
    <>
      <SEO
        title="Página não encontrada"
        description="A página que você está procurando deve ter entrado em um buraco negro. Mas não se preocupe que a TIM é sem fronteiras e te ajudará a voltar!"
      />

      <Container>
        <Columns
          justifyContent="center"
          alignItems="center"
          className="h-screen"
        >
          <Column size={[12, 6]} className="text-center">
            <div className="w-full py-2 text-center">
              <img
                src="/tim_logo.svg"
                alt="Logo da TIM"
                className="inline-block"
              />
            </div>
            <div className="pb-5 pt-3">
              <Text
                as="h2"
                kind="blue"
                className="font-bold leading-none"
                size="xl"
              >
                A página que você estava procurando não foi encontrada
              </Text>
              <Text as="p" kind="gray" className="pt-px">
                Não se preocupe, nós vamos te ajudar! Você pode voltar para a
                página inicial:
              </Text>
            </div>
            <Button type="button" onClick={() => navigate("/")}>
              Voltar para a página inicial
            </Button>
          </Column>
        </Columns>
      </Container>
    </>
  );
};
